import { useCampaignClient } from '@/lib/api'
import { useQuery } from '@tanstack/react-query'
import cx from 'classnames'
import { addHours } from 'date-fns'
import { useEffect, useMemo } from 'react'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import Loading from './loading'
import { ProgressBar } from './progress-bar'

export const CampaignLayout: React.FC = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const location = useLocation()
  const { pathname } = location
  const campaignClient = useCampaignClient()

  const { data: campaignResponse, isLoading } = useQuery({
    queryKey: ['campaign', id],
    queryFn: async () => {
      if (!id) return null
      return await campaignClient.getById.query({
        params: { id },
      })
    },
    enabled: !!id,
    refetchOnMount: 'always',
  })

  const campaign =
    campaignResponse?.status === 200 ? campaignResponse.body : null

  useEffect(() => {
    if (
      campaign &&
      new Date() > addHours(new Date(campaign.startDate), 24) &&
      !campaign.isDraft
    ) {
      navigate('/')
      return
    }
  }, [campaign, navigate])
  const showReferralQuestionnaire = !!campaign?.referralCampaign
  const hasReferralIncentives = useMemo(
    () =>
      campaign?.referralCampaign && !campaign?.reuseSameIncentives
        ? true
        : false,
    [campaign?.referralCampaign, campaign?.reuseSameIncentives],
  )
  const isPreview = pathname.includes('preview')
  return (
    <div className={cx(isPreview ? 'pt-0' : 'flex p-5 gap-24 pt-10')}>
      {!isPreview && (
        <ProgressBar
          completedStep={campaign?.completedStep || 0}
          showReferralQuestionnaire={showReferralQuestionnaire}
          hasReferralIncentives={hasReferralIncentives}
          referral={campaign?.referralCampaign ?? undefined}
          reuseSameIncentives={campaign?.reuseSameIncentives ?? undefined}
        />
      )}
      {isLoading && <Loading />}
      {(!id || (!isLoading && campaignResponse)) && (
        <Outlet context={{ campaign }} />
      )}
    </div>
  )
}
